import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import step1Icon from "@/assets/images/landing-page/step1_icon.png";
import step2Icon from "@/assets/images/landing-page/step2_icon.png";
import step3Icon from "@/assets/images/landing-page/step3_icon.png";
import securityMeasuresIcon from "@/assets/images/landing-page/security-measures.png";
import arrowLeft from "@/assets/images/landing-page/arrow-left.svg";
import { trackCheckCtaClick } from "@/utils/analytics";

import HowItWorksCard from "./HowItWorksCard";

// 4-step product funnel: quick check → action plan → implement → prove
const icons = [step1Icon, step3Icon, securityMeasuresIcon, step2Icon];

type Step = {
	step: string;
	title: string;
	description: string;
	badgeColor: string;
	imgWidth?: number;
	imgHeight?: number;
};

export default function LandingHowItWorksSection() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const steps = t("questionnaire.landingHowItWorksSection.steps", {
		returnObjects: true,
	}) as Step[];

	const handleStartCheck = () => {
		trackCheckCtaClick("how_it_works");
		navigate("/questionnaire/yes");
	};

	return (
		<section className="w-full px-4 md:px-0 bg-[#F7F8FB]">
			<div className="w-full max-w-[1420px] mx-auto my-16 sm:my-[7.5rem] text-center px-4 md:px-8">
				<h2 className="font-urbanist text-[40px] font-semibold leading-[120%] text-[#1D243C] mb-6">
					{t("questionnaire.landingHowItWorksSection.title")}
				</h2>
				<p className="font-urbanist text-[18px] font-normal leading-[150%] text-[#626373] mb-10 max-w-[778px] mx-auto">
					{t("questionnaire.landingHowItWorksSection.description")}
				</p>

				<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 justify-items-center">
					{steps.map((item, index) => (
						<HowItWorksCard
							key={index}
							description={item.description}
							icon={icons[index]}
							imgHeight={item.imgHeight}
							imgWidth={item.imgWidth}
							step={item.step}
							title={item.title}
						/>
					))}
				</div>

				<div className="mt-14 flex justify-center">
					<button
						className="flex items-center gap-2 px-12 py-3 rounded-xl bg-[#4680FC] hover:bg-[#336de0] transition-colors"
						type="button"
						onClick={handleStartCheck}
					>
						<span className="font-urbanist text-[16px] font-medium leading-[22px] text-white">
							{t("questionnaire.landingHowItWorksSection.startCheckButton")}
						</span>
						<img
							alt={t("questionnaire.landingHowItWorksSection.arrowLeftAlt")}
							className="w-5 h-5"
							src={arrowLeft}
						/>
					</button>
				</div>
			</div>
		</section>
	);
}
